// extracted by mini-css-extract-plugin
export default {"labelContainer":"FieldDescription_labelContainer__1acN7"};